import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "./soccer.scss";

import SoccerHeader from "./SoccerHeader";
import DatePickerMatch from "./DatePickerMatch";
import Loading from "../layout/Loading";
import RightLeague from "./RightLeague";

const Soccer = () => {
  const [live, setLive] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchdata = () => {
      fetch(
        `${process.env.REACT_APP_API_FOOTBALL}/livescores/now?api_token=${process.env.REACT_APP_API_TOKEN}&include=localTeam,visitorTeam,league`,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
        }
      )
        .then((res) => {
          return res.json();
        })
        .catch((err) => {
          console.log(err);
        })
        .then((data) => {
          setLoading(false);
          setLive(data.data);
        });
    };
    fetchdata();
  }, []);

  const showloading = () =>
    loading && (
      <div className="d-flex justify-content-center">
        <Loading />
      </div>
    );

  return (
    <div className="container">
      {/* {live.map((livedata) => {
       return {
          livedata.time.status === "LIVE" ? <h2>Live</h2> : "";
        }
      })} */}

      <div className="row">
        <div className="col-sm-9">
          <div className="container mb-5">
            <div className="card mt-2 card-curve">
              <div className="card-body p-0 soccer-bg">
                <h2 className="text-center font-weight-bold text-muted mt-4">
                  <img src="https://img.icons8.com/emoji/50/000000/soccer-ball-emoji.png" />
                  Soccer
                </h2>
                <DatePickerMatch />
              </div>
            </div>

            {/* Live cricket score */}
            <div className="card mt-2 mb-3 card-curve">
              <SoccerHeader />
              <div className="card-header">
                <h6 className="mt-3 ">
                  {" "}
                  <span className="bg-danger text-white pl-1 pr-1 pb-1 rounded">
                    <i className="fas fa-circle round-logo animate__animated animate__flash"></i>{" "}
                    Live
                  </span>{" "}
                  <span className="font-weight-bold">RIGHT NOW</span>
                </h6>
              </div>
            </div>
            {showloading()}
            {live.map((livedata) => {
              return (
                <div key={livedata.id}>
                  {live ? (
                    <Link
                      to={`/matchscore/${livedata.id}`}
                      className="link-item"
                    >
                      {" "}
                      <div className="card soccer-card mt-2 p-3 card-curve">
                        <div className="row mt-2">
                          {/* <div className="col-sm-1">
                        {" "}
                        <p className="status text-center">
                          {" "}
                          {livedata.time.status} &nbsp;
                        </p> 
                      </div> */}
                          <div className="col-sm-3 mb-4">
                            <span>
                              <img
                                src={`${livedata.league.data.logo_path}`}
                                width="40px"
                                height="auto"
                                alt="logo"
                              />{" "}
                              {livedata.league.data.name}
                            </span>
                          </div>
                          <div className="col-sm-3">
                            <p className="soccer-soccer-board text-center">
                              <img
                                src={`${livedata.localTeam.data.logo_path}`}
                                width="30px"
                                alt="logo"
                              />
                              &nbsp;
                              {livedata.localTeam.data.name} &nbsp;&nbsp;
                            </p>
                          </div>
                          <div className="col-sm-2">
                            <h4 className="soccer-score text-center">
                              {" "}
                              {livedata.scores.localteam_score}-
                              {livedata.scores.visitorteam_score}
                            </h4>
                            {/* <p className="text-warning text-center">
                          {livedata.time.minute}
                        </p> */}
                            <p className="status text-center">
                              {" "}
                              {livedata.time.status} &nbsp;
                            </p>
                          </div>
                          <div className="col-sm-4">
                            <p className="soccer-soccer-board text-center">
                              {" "}
                              <img
                                src={`${livedata.visitorTeam.data.logo_path}`}
                                width="30px"
                                alt="logo"
                              />
                              &nbsp;
                              {livedata.visitorTeam.data.name}
                            </p>
                          </div>
                        </div>
                      </div>
                    </Link>
                  ) : (
                    <h2></h2>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <div className="col-sm-3">
          {/* right leages  */}
          <RightLeague />
        </div>
      </div>
    </div>
  );
};

export default Soccer;
